function emailValidator(email) {
  if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,})+$/.test(email)) {
    return true;
  }
  return false;
}

function telephoneNumberValidator(v) {
  return v !== null && v !== undefined && v !== "" && v.length === 9;
}

function DNIValidator(v) {
  if (v === null || v === undefined || v === "") {
    return false;
  }

  const numbers = v.slice(0, 8);
  const validNumbers = numbers.split("").reduce((acc, l) => {
    return acc && !isNaN(parseInt(l));
  }, true);
  const validLetter = v[8] && v[8].match(/^[A-Za-z]+$/) !== null;

  return validNumbers && validLetter;
}

function adultValidator(age) {
  const intAge = parseInt(age);

  return intAge >= 18;
}

function postalCodeValidator(postalCode) {
  return postalCode.match(/^(([0-4][0-9])|(5[0-2]))(\d{3})$/);
}

const valid = () => true;

const VALIDATION_DICTIONARY = {
  email: emailValidator,
  "phone-number": telephoneNumberValidator,
  DNI: DNIValidator,
  adult: adultValidator,
  postalCode: postalCodeValidator,
  none: valid,
};

const DEFAULT_ERROR_MESSAGES = {};
const DEFAULT_ERROR_MESSAGE = "El formato no es válido";

export default function getvalidationError(value, validationConfig) {
  let type, errorMessage;

  if (typeof validationConfig === "string") {
    type = validationConfig;
  } else {
    ({ type, errorMessage } = validationConfig);
  }

  const validator = VALIDATION_DICTIONARY[type] || valid;
  const isValid = validator(value);

  if (isValid) {
    return undefined;
  }
  const message = errorMessage || DEFAULT_ERROR_MESSAGES[type] || DEFAULT_ERROR_MESSAGE;

  return message;
}
